var v1="<div class=\"content-calendar\"><div ng-controller=\"DashboardPeriodFilterCtrl as periodCtrl\" ng-include=\"'dashboard/period-filter/period-filter.jade'\" class=\"bar-calendar {{hideHeader ? 'non-background' : ''}}\"></div></div><div gnp-basic-analysis=\"\" basic-analysis-data=\"basicAnalysisData\" class=\"score-circle-charts-wrap\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/basic-analysis/basic-analysis.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/dashboard/basic-analysis/basic-analysis.jade
// module id = 550
// module chunks = 0